import "core-js/modules/es.array.includes.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/imgs/ic_confirm.png';

const _withScopeId = n => (_pushScopeId("data-v-31cc4407"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "first_box"
};
const _hoisted_2 = {
  class: "main_box"
};
const _hoisted_3 = {
  class: "theme_img"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "form_box"
};
const _hoisted_6 = {
  class: "form_grid"
};
import { useI18n } from 'vue-i18n';
import { fieldVisibilityMap, smallTitleOptions, imageTypeOptions, typeOptions } from '@/assets/config/dicts';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: () => {}
    }
  },
  emits: ['configOk'],

  setup(__props, {
    emit: emits
  }) {
    const props = __props;
    const {
      t
    } = useI18n(); // const smallTitleOptions = ref([
    //   {label: t('开'), value: 1},
    //   {label: t('关'), value: 0}
    // ])
    // const imageTypeOptions = ref([
    //   { label: t('横版'), value: 'vertical' },
    //   { label: t('竖版'), value: 'horizontal' },
    // ])
    // const typeOptions = ref([
    //   { label: t('影片'), value: 'video' },
    //   { label: t('分类'), value: 'category' },
    //   { label: t('分类+更多'), value: 'category_more' },
    // ])

    const pageTypeOptions = ref([]);
    const formData = ref({
      titleOn: 1,
      type: 'category',
      imageType: 'horizontal',
      itemCount: 1,
      categoryCount: 1
    });
    const themeNum = ref('');

    const configOk = () => {
      emits('configOk', formData.value);
    }; // 计算当前应该显示的字段


    const visibleFields = computed(() => {
      const templateCode = props.rowData?.templateCode || 'default';
      return fieldVisibilityMap[templateCode] || fieldVisibilityMap['default'];
    });

    const isFieldVisible = fieldName => {
      return visibleFields.value.includes(fieldName);
    }; //输入框只允许输入大于 0 的正整数，非法输入会自动重置为 1。


    const validateQuantity = type => {
      const value = formData.value[type];

      if (value < 1 || isNaN(value)) {
        formData.value[type] = 1;
      }
    };

    watch(() => props.rowData, newVal => {
      if (newVal) {
        let cloneData = JSON.parse(JSON.stringify(newVal)); // 其他：分类、分类+更多  ||  单行模板: 影片、分类、分类+更多 

        let otherTemplate = ['stb_d_h_r6r6_recommend'];
        pageTypeOptions.value = typeOptions.value;

        if (otherTemplate.includes(newVal.templateCode)) {
          // 双行分类+推荐模板 不存在影片选项
          pageTypeOptions.value = typeOptions.value.filter(item => item.value !== 'video');
        } // 先正常赋值，没有默认值就补充默认值


        formData.value = { ...cloneData,
          titleOn: cloneData.titleOn ? cloneData.titleOn : 1,
          // 默认选中第一个选项
          type: pageTypeOptions.value[0].value,
          imageType: cloneData.imageType ? cloneData.imageType : 'horizontal',
          itemCount: cloneData.itemCount ? cloneData.itemCount : 1,
          categoryCount: cloneData.categoryCount ? cloneData.categoryCount : 1
        }; // 没有对应选项的去掉默认值，防止传给接口有问题

        if (!isFieldVisible('titleOn')) formData.value.titleOn = undefined;
        if (!isFieldVisible('type')) formData.value.type = undefined;
        if (!isFieldVisible('imageType')) formData.value.imageType = undefined;
        if (!isFieldVisible('itemCount')) formData.value.itemCount = undefined;
        if (!isFieldVisible('categoryCount')) formData.value.categoryCount = undefined;
      }
    }, {
      deep: true,
      immediate: true
    });
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_input = _resolveComponent("el-input");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
        src: __props.rowData.layoutImage,
        style: {
          "width": "300px",
          "max-height": "230px",
          "object-fit": "contain"
        },
        alt: ""
      }, null, 8, _hoisted_4)]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [isFieldVisible('type') ? (_openBlock(), _createBlock(_component_el_form_item, {
        key: 0,
        label: _ctx.$t('类型'),
        class: "form_item"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_select, {
          modelValue: formData.value.type,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => formData.value.type = $event),
          placeholder: ""
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pageTypeOptions.value, item => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: item.value,
              label: item.label,
              value: item.value
            }, null, 8, ["label", "value"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      }, 8, ["label"])) : _createCommentVNode("", true), isFieldVisible('itemCount') ? (_openBlock(), _createBlock(_component_el_form_item, {
        key: 1,
        label: _ctx.$t('推荐位数'),
        class: "form_item"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: formData.value.itemCount,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => formData.value.itemCount = $event),
          placeholder: "",
          onInput: _cache[2] || (_cache[2] = $event => validateQuantity('itemCount'))
        }, null, 8, ["modelValue"])]),
        _: 1
      }, 8, ["label"])) : _createCommentVNode("", true), isFieldVisible('categoryCount') ? (_openBlock(), _createBlock(_component_el_form_item, {
        key: 2,
        label: _ctx.$t('分类数'),
        class: "form_item"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: formData.value.categoryCount,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => formData.value.categoryCount = $event),
          placeholder: "",
          onInput: _cache[4] || (_cache[4] = $event => validateQuantity('categoryCount'))
        }, null, 8, ["modelValue"])]),
        _: 1
      }, 8, ["label"])) : _createCommentVNode("", true), isFieldVisible('imageType') ? (_openBlock(), _createBlock(_component_el_form_item, {
        key: 3,
        label: _ctx.$t('推荐位图'),
        class: "form_item"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_select, {
          modelValue: formData.value.imageType,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => formData.value.imageType = $event),
          placeholder: ""
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(imageTypeOptions), item => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: item.value,
              label: item.label,
              value: item.value
            }, null, 8, ["label", "value"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      }, 8, ["label"])) : _createCommentVNode("", true), isFieldVisible('titleOn') ? (_openBlock(), _createBlock(_component_el_form_item, {
        key: 4,
        label: _ctx.$t('小标题'),
        class: "form_item"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_select, {
          modelValue: formData.value.titleOn,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => formData.value.titleOn = $event),
          placeholder: ""
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(smallTitleOptions), item => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: item.value,
              label: item.label,
              value: item.value
            }, null, 8, ["label", "value"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      }, 8, ["label"])) : _createCommentVNode("", true)])])]), _createElementVNode("div", {
        class: "confirm_btn"
      }, [_createElementVNode("img", {
        onClick: configOk,
        style: {
          "height": "40px",
          "width": "40px"
        },
        src: _imports_0,
        alt: ""
      })])]);
    };
  }

});